import lsApi from "../api/lsApi";
import {
    IPagoInmuebleListItem,
    IDetalleCasaPago,
    ITrxCasa,
    IServicioCatalogo,
    IRegistrarPagoRequest,
    IRegistrarPagoResponse,
    ICambiarEstadoPagoRequest,
    ICargaMasivaResultado,
} from '../models/pagosInmuebles';

export function usePagosInmuebles() {

    const getListado = async (agencia?: number) => {
        try {
            const { data, status } = await lsApi.get<IPagoInmuebleListItem[]>('/api/PagosInmuebles/Listado', {
                params: agencia ? { agencia } : {}
            });
            return status === 200 ? data : false;
        } catch {
            return false;
        }
    };

    const getDetalleCasa = async (casa: number, agencia?: number) => {
        try {
            const { data, status } = await lsApi.get<IDetalleCasaPago>(`/api/PagosInmuebles/DetalleCasa/${casa}`, {
                params: agencia ? { agencia } : {}
            });
            return status === 200 ? data : false;
        } catch {
            return false;
        }
    };

    const getHistorialCasa = async (casa: number, agencia?: number) => {
        try {
            const { data, status } = await lsApi.get<ITrxCasa[]>(`/api/PagosInmuebles/HistorialCasa/${casa}`, {
                params: agencia ? { agencia } : {}
            });
            return status === 200 ? data : false;
        } catch {
            return false;
        }
    };

    const getServicios = async () => {
        try {
            const { data, status } = await lsApi.get<IServicioCatalogo[]>('/api/PagosInmuebles/Servicios');
            return status === 200 ? data : false;
        } catch {
            return false;
        }
    };

    const registrarPago = async (pago: IRegistrarPagoRequest) => {
        try {
            const { data } = await lsApi.post<IRegistrarPagoResponse>('/api/PagosInmuebles/RegistrarPago', pago);
            return data;
        } catch (error: any) {
            return (error?.response?.data as IRegistrarPagoResponse) ?? { success: false, message: 'Error al registrar el pago.', id_Abono: 0 };
        }
    };

    const aprobarPago = async (req: ICambiarEstadoPagoRequest) => {
        try {
            const { data } = await lsApi.put<IRegistrarPagoResponse>('/api/PagosInmuebles/AprobarPago', req);
            return data;
        } catch (error: any) {
            return (error?.response?.data as IRegistrarPagoResponse) ?? { success: false, message: 'Error al aprobar el pago.', id_Abono: 0 };
        }
    };

    const anularPago = async (req: ICambiarEstadoPagoRequest) => {
        try {
            const { data } = await lsApi.put<IRegistrarPagoResponse>('/api/PagosInmuebles/AnularPago', req);
            return data;
        } catch (error: any) {
            return (error?.response?.data as IRegistrarPagoResponse) ?? { success: false, message: 'Error al anular el pago.', id_Abono: 0 };
        }
    };

    const reenviarCorreo = async (req: ICambiarEstadoPagoRequest) => {
        try {
            const { data } = await lsApi.put<IRegistrarPagoResponse>('/api/PagosInmuebles/ReenviarCorreo', req);
            return data;
        } catch (error: any) {
            return (error?.response?.data as IRegistrarPagoResponse) ?? { success: false, message: 'Error al reenviar el correo.', id_Abono: 0 };
        }
    };

    const cargaMasiva = async (items: IRegistrarPagoRequest[]) => {
        try {
            const { data } = await lsApi.post<ICargaMasivaResultado[]>('/api/PagosInmuebles/CargaMasiva', items);
            return data;
        } catch {
            return false;
        }
    };

    return {
        getListado,
        getDetalleCasa,
        getHistorialCasa,
        getServicios,
        registrarPago,
        aprobarPago,
        anularPago,
        reenviarCorreo,
        cargaMasiva,
    };
}
